import { ViewModel,View, ObservableArray, ComponentTagMappings } from "binder"
import { stringIsNullOrEmpty } from "src/common/utilities";
import { IStaticValueProvider } from "src/formBuilder/formBuilder/templateEditor/propertiesPanel/editors/IStaticValueProvider";
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { BooleanPropertyType, CustomPropertyType, IPropertyTypeVisitor, IntegerPropertyType, ListPropertyType, TemplateSelectorPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import { ITemplateSelector } from "src/uicomponents/components/templateSelector";
import { getAsBoolean, getAsNumber } from "src/uicomponents/components/utilities";
import { ColumnViewModel } from "uicomponents";
import  { ClientFilterTableView } from "./clientFilterTable-view"
import { ColumnsEditorViewModelViewModel } from "./columnsEditorViewModel/columnsEditorViewModel-viewModel";
import { ReportSelectionViewModel } from "./reportSelection/reportSelection-viewModel";

export class ClientFilterTableComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'ClientFilterTable';
        this.addProperty("Columns","",new ClientFileteringTableColumnsPropertyType(this),null,false);
        this.addProperty("ItemsSource","data-b-comp-items",new ListPropertyType(this),null,false);
        this.addProperty("ItemTemplateSelector","data-b-comp-templateselectorfunction",new TemplateSelectorPropertyType(this),"",false);
        this.addProperty("StickyHeaders","data-b-comp-stickyheader",new BooleanPropertyType(this),false,false);
        this.addProperty("HorizontalScroll","data-b-comp-horizontalscroll",new BooleanPropertyType(this),false,false);
        
        this.addProperty("ExportPdf","data-b-comp-canexportpdf",new BooleanPropertyType(this),false,false);
        this.addProperty("ExportExcel","data-b-comp-canexportexcel",new BooleanPropertyType(this),false,false);
        this.addProperty("AllowPrinting","data-b-comp-canprint",new BooleanPropertyType(this),false,false);
        this.addProperty("AllowRemovingFilter","data-b-comp-canremovefilter",new BooleanPropertyType(this),true,false);
        this.addProperty("ReportFile","data-b-comp-reportfileid",new ReportFilePropertyType(this),null,false);
        this.addProperty("HidePages","data-b-comp-hidepages",new BooleanPropertyType(this),false,false);
        this.addProperty("PageSize","data-b-comp-pagesize",new IntegerPropertyType(this),15,false);
    }

    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new ClientFilterTableElement(parent);
        return result;
    }
        
    protected getClassDefaultValue(){
        return "exTable";
    }
}

export class ClientFilterTableElement extends FormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.ShowingColumns = ObservableArray.create<ColumnViewModel>();
    }
    GetDefaultView(): View <ViewModel> {
        return new ClientFilterTableView();
    }
    public getTypeId(): string {
        return "VM-1F798B90-8A90-433A-BC9D-2E3AB8DBCBF1"
    }
    public set ItemsSource(v: ObservableArray<ViewModel>) { this._ItemsSource = v; } public get ItemsSource(): ObservableArray<ViewModel> { return this._ItemsSource;} private _ItemsSource: ObservableArray<ViewModel>;
    public set TemplateSelector(v: ITemplateSelector) { this._TemplateSelector = v; } public get TemplateSelector(): ITemplateSelector { return this._TemplateSelector;} private _TemplateSelector: ITemplateSelector;
    public set ItemTemplateSelector(v: string) { this._ItemTemplateSelector = v; } public get ItemTemplateSelector(): string { return this._ItemTemplateSelector;} private _ItemTemplateSelector: string;
    public set Columns(v: any) { 
        this._Columns = v; 
        this.updateColumns();
    } public get Columns(): any { return this._Columns;} private _Columns: any;
    public set ShowingColumns(v: ObservableArray<ColumnViewModel>) { this._ShowingColumns = v; } public get ShowingColumns(): ObservableArray<ColumnViewModel> { return this._ShowingColumns;} private _ShowingColumns: ObservableArray<ColumnViewModel>;
    public set ParentTableViewModel(v: ViewModel) { this._ParentTableViewModel = v; } public get ParentTableViewModel(): ViewModel { return this._ParentTableViewModel;} private _ParentTableViewModel: ViewModel;
    public set StickyHeaders(v: boolean) { this._StickyHeaders =getAsBoolean(v); } public get StickyHeaders(): boolean { return this._StickyHeaders;} private _StickyHeaders: boolean;
    public set HorizontalScroll(v: boolean) { this._HorizontalScroll = getAsBoolean(v); } public get HorizontalScroll(): boolean { return this._HorizontalScroll;} private _HorizontalScroll: boolean;
    public set ExportPdf(v: boolean) { this._ExportPdf = getAsBoolean(v); } public get ExportPdf(): boolean { return this._ExportPdf;} private _ExportPdf: boolean;
    public set ExportExcel(v: boolean) { this._ExportExcel = getAsBoolean(v); } public get ExportExcel(): boolean { return this._ExportExcel;} private _ExportExcel: boolean;
    public set AllowPrinting(v: boolean) { this._AllowPrinting = getAsBoolean(v); } public get AllowPrinting(): boolean { return this._AllowPrinting;} private _AllowPrinting: boolean;
    public set ReportFile(v: string) { this._ReportFile = v; } public get ReportFile(): string { return this._ReportFile;} private _ReportFile: string;
    public set AllowRemovingFilter(v: boolean) { this._AllowRemovingFilter = getAsBoolean(v); } public get AllowRemovingFilter(): boolean { return this._AllowRemovingFilter;} private _AllowRemovingFilter: boolean;
    public set HidePages(v: boolean) { this._HidePages = getAsBoolean(v); } public get HidePages(): boolean { return this._HidePages;} private _HidePages: boolean;
    public set PageSize(v: number) { this._PageSize = getAsNumber(v,true); } public get PageSize(): number { return this._PageSize;} private _PageSize: number;
    


    updateColumns(){
        this.ShowingColumns.clear();
        if(stringIsNullOrEmpty(this.Columns)){
            return;
        }
        let columns = JSON.parse(this.Columns).map(x=>{
            let columnType = x.type;
            if(columnType=="emptycolumn"){
                columnType = "stringcolumn";
            }
            let component = <ColumnViewModel><any>(ComponentTagMappings.getComponent(columnType)(this));
            component.fieldname = x.fieldname;
            component.name = x.title;
            return component;
        });
        this.ShowingColumns.update(...columns);
    }

    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitClientFilterTable(this,parameter);
    }

    override onDataContextSet(){
        super.onDataContextSet();
        this.TemplateSelector = this.DataContext._Builder_TemplateSelector__;
    }
}

export class ClientFileteringTableColumnsPropertyType extends CustomPropertyType{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    getEditor(parent: ViewModel) : IStaticValueProvider {
        return new ColumnsEditorViewModelViewModel(parent);
    }
    
}

export class ReportFilePropertyType extends CustomPropertyType{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    
    getEditor(parent: ViewModel) : IStaticValueProvider {
        return new ReportSelectionViewModel(parent);
    }
}